/* eslint-disable @typescript-eslint/no-explicit-any */
import * as v from 'valibot';
export function isQueryContract(key, contract) {
    const method = extractMethodFromKey(key);
    return method === 'GET';
}
export function isBodyContract(key, contract) {
    const method = extractMethodFromKey(key);
    return (method === 'POST' ||
        method === 'PUT' ||
        method === 'PATCH' ||
        method === 'DELETE');
}
// Helper function to extract method from key at runtime
export function extractMethodFromKey(key) {
    const spaceIndex = key.indexOf(' ');
    if (spaceIndex === -1) {
        throw new Error(`Invalid contract key format: ${key}. Expected format: 'METHOD /path'`);
    }
    const method = key.substring(0, spaceIndex);
    return method;
}
// Helper function to extract path from key
export function extractPathFromKey(key) {
    const spaceIndex = key.indexOf(' ');
    if (spaceIndex === -1) {
        throw new Error(`Invalid contract key format: ${key}. Expected format: 'METHOD /path'`);
    }
    return key.substring(spaceIndex + 1);
}
// Helper function to extract path parameter names from a path template
export function extractPathParams(path) {
    const params = [];
    const segments = path.split('/');
    for (const segment of segments) {
        if (segment.startsWith(':')) {
            params.push(segment.substring(1));
        }
    }
    return params;
}
// Helper function to substitute path parameters in a path template
export function substitutePath(pathTemplate, pathParams) {
    let result = pathTemplate;
    for (const [key, value] of Object.entries(pathParams)) {
        result = result.replace(`:${key}`, encodeURIComponent(value));
    }
    return result;
}
export function api(api) {
    return api;
}
export const ErrorResponse = v.object({
    message: v.string(),
    details: v.optional(v.any()),
});
//# sourceMappingURL=_base.js.map